import { t } from "i18next"
import { DocumentLanguage } from "@/modules/patients/libs/document-languages"
import { PregnantStatus, RequestExamination } from "@/types/__generated__/union-types"

const PREGNANT: readonly PregnantStatus[] = ["NOT_PREGNANT", "PREGNANT", "NOT_ENQUIRED"]

type RequestExaminationOption = {
  name: string
  value: RequestExamination
}

type RequestExaminationGroup = {
  heading: string
  options: readonly RequestExaminationOption[]
}[]

const UPPER_LIMBS: readonly RequestExamination[] = [
  "HAND_AP_OBLIQUE",
  "HAND_LAT",
  "WRIST_AP_LAT",
  "LOWERARM_AP_LAT",
  "ELLBOW_AP_LAT",
  "UPPERARM_AP_LAT",
  "SHOULDER_AP_NEER",
  "CLAVICLE_AP_TANGENTIAL",
  "CHEST_X_RAY_TWO_PLANES",
]

const LOWER_LIMBS: readonly RequestExamination[] = [
  "TOE_AP_OBLIQUE",
  "FOOT_AP_OBLIQUE",
  "FOOT_LAT",
  "UAJ_AP_LAT",
  "LOWER_LEG_JOINT",
  "KNEE_AP_LAT",
  "PATELLA_AXIAL",
  "UPPER_LEG_JOINT",
  "PELVIS_AP",
  "HIPJOINT_AXIAL",
  "PELVIS_STANDARD",
]

const REQUEST_EXAMINATION_GROUP: RequestExaminationGroup = [
  {
    heading: t("patient.measRadiologyPrescription.requestExaminations.upperLimbs"),
    options: UPPER_LIMBS.map((item) => ({
      name: t(`patient.measRadiologyPrescription.requestExaminations.${item}`),
      value: item,
    })),
  },
  {
    heading: t("patient.measRadiologyPrescription.requestExaminations.lowerLimbs"),
    options: LOWER_LIMBS.map((item) => ({
      name: t(`patient.measRadiologyPrescription.requestExaminations.${item}`),
      value: item,
    })),
  },
]

const DOCUMENT_LANGUAGES: Array<{ value: DocumentLanguage; label: string }> = [
  { value: "GERMAN", label: "common.languageList.german" },
]

export { PREGNANT, REQUEST_EXAMINATION_GROUP, DOCUMENT_LANGUAGES, type RequestExaminationOption }
